/** Namespace `feedback` — bản gốc tiếng Việt. Khoá phẳng, tên camelCase; `{biến}` để chèn. */
export const feedback = {
  movedToSupport: "Ticket hỗ trợ của khách giờ được xử lý ở « Hỗ trợ » (mọi app). Trang này chỉ còn kho CŨ của bube-shop-staff, không còn app nào ghi vào.",
  openSupport: "Mở Hỗ trợ →",
  "tab.all": "Tất cả",
  loadListFailed: "Không đọc được danh sách phản hồi.",
  noteSaveFailed: "Không lưu được ghi chú.",
  title: "Phản hồi khách hàng",
  introBefore: "Tiêu đề và trích đoạn đã được ",
  introStrong: "lược thông tin cá nhân",
  introAfter: " trước khi lưu. Hub không giữ toàn văn — bấm « Mở trong app gốc » để xem bản đầy đủ.",
  oldestOpen: "Phiếu mở lâu nhất",
  summaryAllAppsBefore: "Bốn ô trên là số của ",
  summaryAllAppsStrong: "tất cả app",
  summaryAllAppsAfter: " — danh sách bên dưới mới lọc theo app đã chọn.",
  emptyTitle: "Không có phiếu nào ở trạng thái này.",
  emptyBefore: "Đây là « không có phiếu », ",
  emptyStrong: "không phải",
  emptyAfter: " « hub không đọc được » — danh sách nguồn chưa đọc được nằm bên dưới.",
  "col.source": "Nguồn",
  "col.title": "Tiêu đề (đã lược)",
  "col.status": "Trạng thái",
  "col.submittedAt": "Gửi lúc",
  "col.notes": "Ghi chú",
  nativeStatusTitle: "Nguồn gọi là: {status}",
  note: "Ghi chú",
  openInSourceApp: "Mở trong app gốc",
  noteLabel: "Ghi chú nội bộ cho « {title} » — KHÔNG gửi cho khách hàng",
  saveNote: "Lưu ghi chú",

  loadDetailFailed: "Không đọc được phản hồi này.",
  backToList: "← Phản hồi",
  nativeStatus: " (nguồn gọi là « {status} »)",
  submittedAt: " · gửi {at}",
  excerpt: "Trích đoạn (đã lược)",
  hubKeepsOnly: "Hub chỉ giữ tiêu đề và một trích đoạn, cả hai đã lược thông tin cá nhân.",
  fullInSourceApp: " Bản đầy đủ nằm ở app gốc.",
  internalNotes: "Ghi chú nội bộ ({count})",
  noNotesBefore: "Chưa có ghi chú nào. Ghi chú ở đây ",
  noNotesStrong: "không",
  noNotesAfter: " gửi cho khách hàng.",
  addNoteLabel: "Thêm ghi chú — KHÔNG gửi cho khách hàng",
  noReplyV1:
    "Hub không có đường trả lời khách hàng ở V1 — đó là hành động ra bên ngoài, và nó cần phê duyệt cùng đường thu hồi trước khi mở.",
} as const;
